import { Appointments, QueueSettings } from '@prisma/client';
import API_URL from '../apiconfig';
import {
  QueueAppointment,
  QueueSettingsPayload,
  RemoveFromQueuePayload,
} from '../types/queue';
import axios from './api';
import client from '../utils/react-query/client';

export const updateQueueSettings = async (
  businessId: string,
  payload: QueueSettingsPayload,
) => {
  const response = await axios.patch(
    `${API_URL}/v1/businesses/${businessId}/queue-settings`,
    payload,
  );

  return response.data.result as QueueSettings;
};

export const getQueue = async (businessId: string) => {
  const response = await axios.get(`${API_URL}/v1/appointments/queue`, {
    params: {
      businessId,
    },
  });

  return response.data.result as QueueAppointment[];
};

export const removeFromQueue = async (
  appointmentId: string,
  payload: RemoveFromQueuePayload,
) => {
  const response = await axios.delete(
    `${API_URL}/v1/appointments/${appointmentId}/queue`,
    { data: payload },
  );
  return response.data.result as Appointments;
};

export const invalidateQueue = async () => {
  await client.invalidateQueries({ queryKey: ['queue'] });
};

export const moveBackToQueue = async (appointmentId: string) => {
  const response = await axios.patch(
    `${API_URL}/v1/appointments/${appointmentId}/queue`,
  );
  return response.data.result as Pick<Appointments, 'appointmentId' | 'status'>;
};
